import { db } from '../firebase'
import _ from 'lodash'

const state = {
  topProducts: [],
  topBrands: [],
  topCatalogs: [],
}

const getters = {
  topProducts: state => _.sortBy(state.topProducts, 'weight'),
  topBrands: state => _.sortBy(state.topBrands, 'weight'),
  topCatalogs: state => _.sortBy(state.topCatalogs, 'weight'),
}

const actions = {
  async fetchLandingPage({ commit }) {
    const snap = await db.collection('landingPage').doc('landingPage').get()
    const { topProducts, topBrands, topCatalogs } = snap.data()
    commit('setTopProducts', topProducts)
    commit('setTopBrands', topBrands)
    commit('setTopCatalogs', topCatalogs)
  }
}

const mutations = {
  setTopProducts(state, topProducts) {
    state.topProducts = topProducts
  },
  setTopBrands(state, topBrands) {
    state.topBrands = topBrands
  },
  setTopCatalogs(state, topCatalogs) {
    state.topCatalogs = topCatalogs
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
}
